import axios from 'axios'
import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { login, reset } from '../../features/auth/authSlice'
import Spinner from '../../components/spinner'
import { MDBInput } from 'mdb-react-ui-kit';
import Logo from "../../img/LogoName.png";
import Logores from "../../img/logoresponsive.png";
import '../../styles/index.css'
import { resetPasswordEmail } from "../../features/auth/authSlice";
import { NewFooter } from "../../components/newFooter";

export function ForgotPasswordEmail() {
  const dispatch = useDispatch()
  const [done, setDone] = useState(false);
  const [formData, setFormData] = useState({
    email: "", 
  })

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const checkdata = (data) => {
      if (data.email === "" ) {
        setDone(false)
      } else {
        setDone(true)
      }

    }
    checkdata(formData)
  }, [formData, done])

  console.log(alert)
  const getWindowDimensions = () => {
    const { innerWidth: width } = window;
    return {
      width,
    };
  }
  const windowWidth = getWindowDimensions();
  console.log(windowWidth)

  return (
    <>
      <div className="signupGradientbg3">
        <div className="bgwhitePassword">
          <div className='p-3 px-4 mt-1'>
            <Link className="text-decoration-none" to="/practitionerLogin"><span className='dark-text'><i className="fas fa-less-than me-2"></i> Back</span></Link>
          </div>

          <div className='text-responsive p-resposnive mb-3'>
            <h3 className='titlesingup'>Forgot password?</h3>
          </div>


            <div className='mb-3 text-left'>
            <p className='text-p px-4 top-m'>Reset your password</p>
            <p className='px-4'>Enter the email associated with your account and we’ll email<br/> you with instructions how to reset your password.</p>
            </div>

          <div className='px-4 mt-4'>
          <div className=''>
            <div className='block'>
              <label className='mt-1 text-p'>Email address</label>
              <input className='input-new-password input-border'
                onChange={handleChange}
                value={formData.email}
                name="email"></input>
            </div>
           
            </div>
          </div>


          <div className='button-center top-m'>
            <button className={done ? "button-active-password  blue-hover mt-2" : "button-disable-password  mt-2"} disabled={!done} onClick={()=> {
              dispatch(resetPasswordEmail(formData))
              setFormData({ email: ''});
            }}>RESET PASSWORD</button>
          </div>
        </div>

      </div>
      <NewFooter show={windowWidth.width < 500 ? false : true} />
    </>
  )
}